import type { CSSProperties } from "react";

const THEME_COLOR_CLASSES = {
  "theme-ink": "tag-color-theme-ink",
  "theme-graphite": "tag-color-theme-graphite",
  "theme-smoke": "tag-color-theme-smoke",
  "theme-mist": "tag-color-theme-mist",
} as const;

const THEME_SWATCH_CLASSES = {
  "theme-ink": "tag-swatch-theme-ink",
  "theme-graphite": "tag-swatch-theme-graphite",
  "theme-smoke": "tag-swatch-theme-smoke",
  "theme-mist": "tag-swatch-theme-mist",
} as const;

type ThemeTagColor = keyof typeof THEME_COLOR_CLASSES;

export const TAG_COLOR_OPTIONS = [
  { name: "pink", value: "#ec4899" },
  { name: "red", value: "#ef4444" },
  { name: "orange", value: "#f97316" },
  { name: "amber", value: "#f59e0b" },
  { name: "lime", value: "#84cc16" },
  { name: "emerald", value: "#10b981" },
  { name: "teal", value: "#14b8a6" },
  { name: "cyan", value: "#06b6d4" },
  { name: "blue", value: "#3b82f6" },
  { name: "violet", value: "#8b5cf6" },
  { name: "ink", value: "theme-ink" },
  { name: "graphite", value: "theme-graphite" },
  { name: "smoke", value: "theme-smoke" },
  { name: "mist", value: "theme-mist" },
] as const;

function isThemeTagColor(color: string): color is ThemeTagColor {
  return color in THEME_COLOR_CLASSES;
}

export function tagColorClassName(color: string | null | undefined): string | undefined {
  if (!color || !isThemeTagColor(color)) return undefined;
  return THEME_COLOR_CLASSES[color];
}

export function tagColorStyle(color: string | null | undefined): CSSProperties | undefined {
  if (!color || isThemeTagColor(color)) return undefined;
  return { color };
}

export function tagSwatchClassName(color: string): string | undefined {
  if (!isThemeTagColor(color)) return undefined;
  return THEME_SWATCH_CLASSES[color];
}

export function tagSwatchStyle(color: string): CSSProperties | undefined {
  if (isThemeTagColor(color)) return undefined;
  return { background: color };
}
